<template>
  <TelaCheia v-model="telaCheia" :titulo="'Dashboard'">
    <sys-data-table
      id="data-table-dash-lista-produtos"
      v-model="produtosSelecionados"
      :height="heightDataTable"
      :items="LISTA_PRODUTOS_COMPUTED"
      :loading="loadingTable"
      :headers="CABECALHOS_COMPUTED"
      :item-height="50"
      item-key="index"
      class="elevation-3"
      desativar_ordenacao
      :item-class="classesProduto"
      :class="{'mx-1': telaCheia}"
      :show-select="!filtros.exibir_produtos_combinados"
      @scroll-items="buscarProdutosSeTiverNoFinalDaRolagem($event)"
      @click:th="() => abrir_dialog_ordenacao_count++"
    >
      <template #top>
        <Ordenacao
          id_unico_preferencia="ORDENACAO_TABELA_LISTA_PRODUTOS_TELA_DASHBOARD"
          :itens="colunas_ordenacao"
          :abrir_dialog_ordenacao_count="abrir_dialog_ordenacao_count"
          @update:ordenacao="() => resetarCarregamentoProdutos()"
          @campos:ordenacao="atualizarCamposOrdenados"
        />

        <TopDataTable
          v-model="telaCheia"
          class="py-1"
          :disabled="loadingTable"
          :produtos="produtosSelecionados"
          :tela_cheia="telaCheia"
          :reset_filtros_top="reset_filtros_top"
          @update:reset_filtros_top="reset_filtros_top = $event"
          @update:apenas_itens_ativos="filtros.apenas_itens_ativos = $event"
          @update:txt-pesquisa="pesquisa = $event"
          @update:nivel-estoque="filtros.nivelEstoque = $event"
        >
          <template #right.prepend>
            <CadastroProdutoCombinado
              v-if="produtosSelecionados.length > 1"
              :id="String(produto_combinado_para_edicao.id_produto || '')"
              :descricao="produto_combinado_para_edicao.nome_produto"
              :produtos="Helpers.arrayColumn(produtosSelecionados, 'id_produto')"
              @salvo-sucesso="produtoCombinadoSalvo()"
              @cancelar="produtosSelecionados = []"
            />

            <v-switch
              v-else
              v-model="filtros.exibir_produtos_combinados"
              hide-details
              class="mt-1 mr-5"
              color="#A51B32"
              :disabled="loadingTable"
            >
              <template #label>
                <span class="ml-2">Exibir produtos combinados</span>
              </template>
            </v-switch>
          </template>
        </TopDataTable>
      </template>

      <template v-for="(item, key) in campos_em_ordenacao" #[`header.${item.campo}.icon_order`]>
        <span :key="key">
          <v-icon v-if="item.ordem === 'DECRESCENTE'" small v-text="'mdi-arrow-down'" />
          <v-icon v-else small v-text="'mdi-arrow-up'" />
        </span>
      </template>

      <template #header.data-table-select>&nbsp;</template>

      <template #item.data-table-select-td="{item, isSelecded}">
        <span v-if="item.produto_esta_combinado && !isSelecded">
          <Legenda titulo="Produto Combinado" legenda="Este produto já está em uma combinação.">
            <v-icon color="#CECECE" class="cursor-help">mdi-checkbox-blank-outline</v-icon>
          </Legenda>
        </span>
      </template>

      <template #item.id_produto="{item}">
        <div class="d-flex align-center justify-center">
          <p class="ma-0 w-full text-center">{{item.id_produto}}</p>

          <v-spacer />

          <DetalhesProdutoCombinado
            v-if="filtros.exibir_produtos_combinados"
            :id_grupo="Number(item.id_grupo)"
            :produtos="item.produtos"
          />

          <DetalhesProduto
            v-else
            class="text-right"
            :produto="{...item, id_filial: 9999}"
            :disabled="loadingTable"
            habilitar_edicao_parametros
          />
        </div>
      </template>

      <template #item.nome_fornecedor="{item}">
        {{ `${item.id_fornecedor} - ${item.nome_fornecedor}` }}
      </template>

      <template #item.existe_necessidade_drp="{item}">
        {{ item.existe_necessidade_drp ? 'SIM' : 'NÃO' }}
        <AnaliseDrpEstoqueFiliais
          :idgrupo="parseInt(item.id_grupo)"
          :idproduto="String(item.id_produto)"
          :descricao_produto="item.nome_produto"
          content_class="mt-n2px"
        />
      </template>

      <template #item.data_ultima_venda="{item}">
        <span v-if="item.data_ultima_venda">{{ item.data_ultima_venda }}</span>
        <span v-else :class="corTextoItemForaDeLinha(item)">Sem venda</span>
      </template>

      <template #item.data_ultima_compra="{item}">
        <span v-if="item.data_ultima_compra" v-text="item.data_ultima_compra" />
        <span v-else :class="corTextoItemForaDeLinha(item)" v-text="'Sem compra'" />
      </template>

      <template #item.preco_custo="{item}">
        {{ Helpers.formatarValorMonetario(item.preco_custo, item.moeda) }}
      </template>

      <template #item.preco_venda="{item}">
        {{ Helpers.formatarValorMonetario(item.preco_venda, item.moeda) }}
      </template>

      <template #item.nivel_estoque="{item}">
        {{ niveisDeEstoque[item.nivel_estoque] }}
      </template>

      <template #item.lista_pedidos_em_aberto="{item}">
        <PedidosEmTransitoDialog v-if="item.lista_pedidos_em_aberto" :produto="item" :disabled="loadingTable" />
        <p v-else class="ma-0" :class="corTextoItemForaDeLinha(item)" v-text="'Nenhum'" />
      </template>

      <template #item.opcoes="{item}">
        <div v-if="filtros.exibir_produtos_combinados" class="d-flex align-center">
          <ComparacaoProdutos
            :id_grupo="Number(item.id_grupo)"
            :id_produto_combinado="String(item.id_produto)"
            :produtos="item.produtos"
          />

          <v-btn icon @click="carregarEdicaoProdutoCombinado(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <ExclusaoProdutoCombinado
            :id="String(item.id_produto)"
            @produto-combinado-apagado="resetarCarregamentoProdutos()"
          />

          <IrParaTelaComprasFornecedor
            :id_grupo="Number(item.id_grupo)"
            :produtos="item.produtos"
            :id_produto_combinado="String(item.id_produto)"
            :nome_produto_combinado="item.nome_produto"
          />
        </div>

        <template v-else>
          <v-tooltip v-if="item.status === 'FL'" top open-delay="700">
            <template v-slot:activator="{on, attrs}">
              <v-btn icon color="error" v-bind="attrs" v-on="on">
                <v-icon>mdi-alert</v-icon>
              </v-btn>
            </template>
            <span>Produto Fora de Linha</span>
          </v-tooltip>

          <v-tooltip v-else-if="item.revenda === 'N'" top open-delay="700">
            <template v-slot:activator="{on, attrs}">
              <v-btn icon color="orange" v-bind="attrs" v-on="on">
                <v-icon size="20">mdi-cart-remove</v-icon>
              </v-btn>
            </template>
            <span>Produto inativo para revenda</span>
          </v-tooltip>

          <v-btn v-else icon :disabled="loadingTable" @click="pushTelaCompras(item)">
            <v-icon>mdi-cart</v-icon>
          </v-btn>
        </template>
      </template>

      <template #body.append v-if="todosItensPaginadosCarregados && desserts.length > 50">
        <div class="d-flex align-center justify-center py-4 text-gray-400">
          <v-icon left>mdi-sort-descending</v-icon>
          FIM DA TABELA
        </div>
      </template>

      <template #footer="{countItems}">
        <FooterDataTable :countItems="countItems" class="px-2" />
      </template>
    </sys-data-table>
  </TelaCheia>
</template>

<script>
import {mapGetters} from "vuex";
import TelaCheia from "../../utils/TelaCheia";
import DashboardAPI from "../../../api/dashboard";
import PedidosEmTransitoDialog from "./PedidosEmTransitoDialog";
import {arrayColumn, buscarCompraFornecedor} from "../../../helpers/index";
import DetalhesProduto from "../../produto/detalhes/Index";
import TopDataTable from "./TopDataTable";
import NiveisDeEstoque from "./NiveisDeEstoque";
import HeadersDataTable from "./HeadersDataTable";
import ReponsividadeDeAltura from "./../../../helpers/ResponsiveHeight.js"
import FooterDataTable from "./FooterDataTable";
import AnaliseDrpEstoqueFiliais from "@/components/produto/DRP/AnaliseEstoqueFiliais/Index.vue";
import Legenda from "@/components/produto/detalhes/Legenda.vue";
import CadastroProdutoCombinado from "@/components/produto/DemandaCombinada/CadastroProdutoCombinado/Index.vue";
import ExclusaoProdutoCombinado from "@/components/produto/DemandaCombinada/ExclusaoProdutoCombinado.vue";
import ComparacaoProdutos from "@/components/produto/DemandaCombinada/ComparacaoProdutos/Index.vue";
import DetalhesProdutoCombinado from '@/components/produto/DemandaCombinada/DetalhesProdutos/Index.vue';
import IrParaTelaComprasFornecedor from "@/components/produto/DemandaCombinada/IrParaTelaComprasFornecedor.vue";
import Ordenacao from "@/components/utils/dataTable/Ordenacao.vue";
import { colunas_ordenacao } from "./Cabecalho.js";

export default {
  name: "TabelaListaProdutos",
  components: {
    IrParaTelaComprasFornecedor,
    Legenda,
    AnaliseDrpEstoqueFiliais,
    FooterDataTable,
    TopDataTable,
    TelaCheia,
    PedidosEmTransitoDialog,
    DetalhesProduto,
    CadastroProdutoCombinado,
    ExclusaoProdutoCombinado,
    ComparacaoProdutos,
    DetalhesProdutoCombinado,
    Ordenacao
  },
  mixins: [NiveisDeEstoque, ReponsividadeDeAltura],
  data: () => ({
    headers: HeadersDataTable,
    desserts: [],
    produtosSelecionados: [],
    pesquisa: '',
    reset_filtros_top: false,
    filtros: {
      apenas_itens_ativos: true,
      exibir_produtos_combinados: localStorage.dash_produtos_flag_exibir_produtos_combinados === 'S',
      nivelEstoque: []
    },
    timerScrollDataTable: null,
    timerPesquisaKeyPress: null,
    telaCheia: false,
    loadingTable: false,
    itensPorPagina: 300,
    todosItensPaginadosCarregados: false,
    buscagemDeProdutosBloqueada: false,
    produto_combinado_para_edicao: {},
    colunas_ordenacao: colunas_ordenacao,
    abrir_dialog_ordenacao_count: 0,
    campos_em_ordenacao: [],
  }),
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
    paginaItensAtual() {
      return Math.ceil(this.desserts.length / this.itensPorPagina);
    },
    heightDataTable(){
      return this.telaCheia ? (this.alturaDaJanela - 140) : (this.alturaDaJanela - 403);
    },
    LISTA_PRODUTOS_COMPUTED() {
      if (this.produtosSelecionados.length === 0) {
        return this.desserts;
      }

      const array_index = arrayColumn(this.produtosSelecionados, 'index')
      const produtos_nao_selecionados = this.desserts.filter(item => !array_index.includes(item.index));

      return [
        ...this.produtosSelecionados,
        ...produtos_nao_selecionados
      ];
    },
    CABECALHOS_COMPUTED() {
      let headers_tmp = this.headers;

      if (this.filtros.exibir_produtos_combinados) {
        headers_tmp = headers_tmp.filter(item => !item.ocultar_em_produtos_combinados);
      }

      if (localStorage.ativar_exibicao_campo_numero_original !== 'S') {
        headers_tmp = headers_tmp.filter(item => item.value !== 'numero_original');
      }

      return headers_tmp;
    }
  },
  watch: {
    grupoCompra () {
      this.resetarCarregamentoProdutos();
    },
    pesquisa() {
      this.resetarCarregamentoProdutos();
    },
    'filtros.nivelEstoque': function () {
      this.resetarCarregamentoProdutos();
    },
    'filtros.apenas_itens_ativos': function () {
      this.resetarCarregamentoProdutos();
    },
    'filtros.exibir_produtos_combinados': function () {
      this.produtosSelecionados = [];
      this.resetarCarregamentoProdutos();
      localStorage.dash_produtos_flag_exibir_produtos_combinados = this.filtros.exibir_produtos_combinados ? 'S' : 'N'
    },
    'produtosSelecionados.length': function (length) {
      if (length === 0) {
        this.produto_combinado_para_edicao = {};
      }
    }
  },
  mounted() {
    this.getProdutos();
  },
  methods: {
    atualizarCamposOrdenados(campos) {
      this.campos_em_ordenacao = campos;
      this.$forceUpdate();
    },
    corTextoItemForaDeLinha(produto) {
      return {
        'error--text': produto.status === 'FL',
        'text-gray-100': produto.status !== 'FL',
      }
    },
    classesProduto(produto) {
      return {
        'text-red': produto.status === 'FL',
        'text-gray-100': produto.produto_esta_combinado,
        'bg-gray-200': this.produtosSelecionados.some(item => item.index === produto.index)
      };
    },
    resetarCarregamentoProdutos() {
      this.desserts = [];
      this.todosItensPaginadosCarregados = false;
      this.getProdutosAposUmTempo();
    },
    getProdutosAposUmTempo() {
      this.loadingTable = true;
      clearTimeout(this.timerPesquisaKeyPress);
      this.timerPesquisaKeyPress = setTimeout(() => this.getProdutos(), 500);
    },
    buscarProdutosSeTiverNoFinalDaRolagem({scrollHeight, scrollTop, offsetHeight}) {
      if ((scrollTop + offsetHeight + 50) < scrollHeight || this.loadingTable) {
        return;
      }

      clearTimeout(this.timerScrollDataTable);
      this.timerScrollDataTable = setTimeout(() => this.getProdutos(), 500);
    },
    getProdutos() {
      if (this.todosItensPaginadosCarregados || this.buscagemDeProdutosBloqueada) {
        return;
      }

      this.loadingTable = true;

      const produtos_obrigados_no_resultado = this.produto_combinado_para_edicao.carregar_produtos_edicao
        ? this.produto_combinado_para_edicao.produtos
        : [];

      const comprador = this.$store.getters['usuario/getComprador'];
      const params = {
        idGrupo: this.grupoCompra,
        pagina: (this.paginaItensAtual + 1),
        itensPorPagina: this.itensPorPagina,
        pesquisa: this.pesquisa,
        nivelEstoque: this.filtros.nivelEstoque,
        apenas_itens_ativos: this.filtros.apenas_itens_ativos ? 'S' : 'N',
        exibir_produtos_combinados: this.filtros.exibir_produtos_combinados ? 'S' : 'N',
        idcomprador: comprador.id ? comprador.id : 0,
        produtos_obrigados_no_resultado
      }

      DashboardAPI.getProdutosGrupoPaginados(params)
        .then(resp => {
          const {token, produtos} = resp.data;
          localStorage.token = token;
          this.desserts = this.desserts.concat(produtos);
          this.loadingTable = false;

          if (produtos.length < this.itensPorPagina) {
            this.todosItensPaginadosCarregados = true;
          }

          this.bloquearBuscagemProdutosPorUmTempo();

          if (this.produto_combinado_para_edicao.carregar_produtos_edicao) {
            this.selecionarProdutosCombinadosParaEdicao();
          }
        })
        .catch(() => this.Helpers.logout())
    },
    bloquearBuscagemProdutosPorUmTempo() {
      const TRES_SEGUNDOS = 3000;
      setTimeout(() => (this.buscagemDeProdutosBloqueada = false), TRES_SEGUNDOS);
    },
    selecionarProdutosCombinadosParaEdicao() {
      const callback = item => this.produto_combinado_para_edicao.produtos
        .some(idproduto => String(idproduto) === String(item.id_produto))

      this.produtosSelecionados = this.desserts.filter(callback);
      this.produto_combinado_para_edicao.carregar_produtos_edicao = false;
    },
    pushTelaCompras(item) {
      const fornecedorSelecionado = {
        id: item.id_fornecedor,
        razao_social: item.nome_fornecedor,
        produto: {
          id_produto: item.id_produto,
          nome_produto: item.nome_produto
        }
      };

      buscarCompraFornecedor(fornecedorSelecionado, 1);
    },
    carregarEdicaoProdutoCombinado(item) {
      this.reset_filtros_top = true;
      this.produto_combinado_para_edicao = {...item, carregar_produtos_edicao: true};
      this.filtros.exibir_produtos_combinados = false;
      this.resetarCarregamentoProdutos();
    },
    produtoCombinadoSalvo() {
      if (this.produto_combinado_para_edicao.id_produto) {
        this.filtros.exibir_produtos_combinados = true;
      } else {
        this.resetarCarregamentoProdutos();
      }

      this.produto_combinado_para_edicao = {};
      this.produtosSelecionados = [];
    }
  }
}
</script>

<style scoped>
</style>
